import React from 'react';
import * as FooterBottomStyle from "./footerBottom.module.scss"

function FooterBottom() {
  const currentYear = new Date().getFullYear()
  const url = process.env.GATSBY_WEBSITE_URL;
  return (
    <div className={FooterBottomStyle.bottom}>
      <div className={FooterBottomStyle.bottom__left}>
        All Rights Reserved ® Trafft {currentYear}
      </div>
      <div className={FooterBottomStyle.bottom__right}>
        <a href={url + 'terms-of-service/'} className={FooterBottomStyle.bottom__right__item}>
          Terms of Service
        </a>
        <a href={url + 'privacy-policy/'} className={FooterBottomStyle.bottom__right__item}>
          Privacy Policy
        </a>
      </div>
    </div>
  );
}

export default FooterBottom;